import { ArrowButtonDownBold, ArrowButtonUpBold } from '@ha/icons';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { useIntl } from 'ha/i18n';
import { Grid, Link } from '@hbf/dsl';

interface Props {
  showMore: boolean;
  handleClick: () => void;
  dataTestLocator?: string;
}

const useStyles = makeStyles()(theme => ({
  icon: {
    fontSize: 8,
  },
  link: {
    padding: theme.spacing(0.5, 0),
    cursor: 'pointer',
  },
}));

const ShowMore: React.FC<Props> = ({
  showMore,
  handleClick,
  dataTestLocator = '',
}) => {
  const { T } = useIntl();
  const { classes } = useStyles();

  const handleShowMoreClick = React.useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      event.preventDefault();
      handleClick();
    },
    [handleClick],
  );

  return (
    <Grid container component="span">
      <Link
        to={undefined!}
        kind="underline"
        onClick={handleShowMoreClick}
        className={classes.link}
        data-test-locator={dataTestLocator}
      >
        {showMore ? (
          <React.Fragment>
            {T('Show more')} <ArrowButtonDownBold className={classes.icon} />
          </React.Fragment>
        ) : (
          <React.Fragment>
            {T('Show less')} <ArrowButtonUpBold className={classes.icon} />
          </React.Fragment>
        )}
      </Link>
    </Grid>
  );
};

export { ShowMore };
